<template>
  <div class="px-8 mt-4">
    <v-dialog v-model="dialogItemType" persistent width="670px">
      <v-card>
        <v-card-title>
          <span class="subheader"> Choose Document Type:</span>
          <v-spacer></v-spacer>
          <v-btn icon dark color="secondary2" @click="clickCloseMainDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
          <v-card-text>
            <v-form @submit.prevent ref="formItemType">
                  <v-chip-group
                    v-model="formData.DocTypeID"
                    active-class="header white--text"
                    class="ma-2"
                  >
                    <v-chip v-for="rt in doc_types" :value="rt.id" :key="'rt-' + rt.id" large class="px-5 chip-width">
                      <v-icon left>
                        {{rt.icon}}
                      </v-icon>
                        {{rt.description}}
                    </v-chip>
                  </v-chip-group>
                  </v-form>
          </v-card-text>
        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" outlined @click="clickCloseMainDialog()"> Cancel </v-btn>
          <v-btn
            color="header"
            class="white--text"
            @click="saveItemType()"
            :loading="isLoading"
            :disabled="formData.DocTypeID == null"
          >
          <v-icon class="mr-1">mdi-checkbox-marked-outline</v-icon>
            Select
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogModel"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      class="poModal"
      scrollable
    >
      <v-card>
        <v-toolbar dark color="green darken-2" max-height="65">
          <v-toolbar-title>Generate Stickers</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="clickCloseMainDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="max-height: 900px">
          <div>
            <v-row class="mt-4">
              <v-col cols="12" class="d-flex justify-center">
                <v-subheader class="font-weight-bold text-h6 text-center">
                  CREATION OF BATCHED STICKERS
                </v-subheader>
              </v-col>
            </v-row>
          </div>
          <v-row>
            <v-col cols="12" class="py-0 my-0 mt-8">
              <v-toolbar flat dense>
                    <v-autocomplete
                    v-model="formData.DocTypeID"
                    @change="getItems()"
                    item-text="description"
                    item-value="id"
                    :rules="[formRules.required]"
                    :items="doc_types"
                    class="mr-4"
                    label="Select a Doc Type"
                    style="max-width: 300px"
                    color="header"
                    hide-details
                  >
                  </v-autocomplete>
                  <v-autocomplete
                  v-if="formData.DocTypeID == 2"
                    v-model="formData.StickerTypeID"
                    @change="getItems()"
                    item-text="description"
                    item-value="id"
                    :rules="[formRules.required]"
                    :items="sticker_types"
                    class="mr-4"
                    label="Select a Sticker Type"
                    style="max-width: 300px"
                    color="header"
                    :value="1"
                    hide-details
                  >
                  </v-autocomplete>
                  <v-autocomplete
                  v-else
                    disabled
                    item-text="description"
                    item-value="id"
                    :rules="[formRules.required]"
                    :items="sticker_types"
                    class="mr-4"
                    label="Select a Sticker Type"
                    style="max-width: 300px"
                    color="header"
                    :value="1"
                    hide-details
                  >
                  </v-autocomplete>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-2"
                      outlined
                      class="mr-2"
                      :disabled="formData.Lists.length == 0"
                      @click="preview()"
                    >
                      <v-icon class="mr-1">mdi-eye</v-icon>
                      PREVIEW
                    </v-btn>
                    <v-btn
                      color="green darken-2"
                      class="white--text"
                      :disabled="formData.Lists.length == 0"
                      @click="generate()"
                    >
                      <v-icon class="mr-1">mdi-sticker-plus</v-icon>
                      GENERATE STICKERS
                    </v-btn>
                  </v-toolbar>
            </v-col>
            <v-col lg="12" class="">
              <v-data-table
                v-model="formData.Lists"
                :headers="headers"
                :items="itemList"
                item-key="Code"
                class="elevation-1 mt-4"
                :search="searchText"
                :expanded.sync="expanded"
                :loading="isLoading"
                :show-expand="false"
                show-select
                @toggle-select-all="selectAllToggle"
                :items-per-page="-1"
                :footer-props="{
                  'items-per-page-options': [-1]
                }"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <span class="green--text text--darken-2"
                      >List of {{ getDescription(formData.DocTypeID)}}</span
                    >
                    <v-spacer></v-spacer>
                    <v-text-field
                    v-model="searchText"
                    append-icon="mdi-magnify"
                    label="Search Item here..."
                    style="max-width: 300px"
                    color="header"
                    hide-details
                  >
                  </v-text-field>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
                  <v-simple-checkbox
                    :value="isSelected"
                    :ripple="false"
                    :readonly="item.disabled"
                    :disabled="item.disabled"
                    @input="select($event)"
                  ></v-simple-checkbox>
                </template>
                <template v-slot:[`item.UnitCost`]="{ item }">
                  <span class="text-no-wrap">₱ {{ formatPrice(item.UnitCost) }}</span>
                </template>
                <template v-slot:[`item.Qty`]="{ item }">
                    {{ formatQty(item.Qty) }}
                </template>
                <template v-slot:[`item.Amount`]="{ item }">
                  <span class="text-no-wrap">₱ {{formatPrice(parseFloat(item.UnitCost) * parseFloat(item.Qty))}}</span>
                </template>
                <template v-slot:[`item.Remarks`]="{ item }">
                  <span :class="item.RemarksID == 1 ? 'green--text' : item.RemarksID == 2 ? 'red--text' : ''">{{item.Remarks}}</span>
                </template>
                <template v-slot:[`item.TransferQty`]="{ item }">
                  {{formatQty(item.TransferQty)}}
                </template>
                <template v-slot:[`item.DisposeQty`]="{ item }">
                  {{formatQty(item.DisposeQty)}}
                </template>
                <!-- <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <div class="my-5">
                    <v-row v-for="(mr, index) in item.MRData" :key="index">
                      <v-col cols="12" class="px-2">
                        <v-row>
                          <v-col cols="12" sm="3">
                            <strong>Persons Accountable: </strong>
                          </v-col>
                          <v-col cols="12" sm="9">
                            {{getPANames(mr.UserID)}}
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="4" class="px-2">
                         <strong>Brand: </strong> {{mr.Brand || 'Not applicable'}}
                      </v-col>
                      <v-col cols="12" sm="4" class="px-2">
                        <strong>Brand: </strong> {{mr.Model || 'Not applicable'}}
                      </v-col>
                      <v-col cols="12" sm="4" class="px-2">
                        <strong>Serial No.: </strong> {{mr.SerialNo || 'Not applicable'}}
                      </v-col>
                      <v-col v-if="item.MRData.length > index + 1 "><v-divider></v-divider></v-col>
                    </v-row>
                    </div>
                  </td>
                </template> -->
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-dialog v-model="dialogProcess" max-width="1250px" scrollable>
        <v-card>
          <v-card-title class="headline pt-5">
            <span>Generate Stickers ({{formData.Lists.length}})</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogProcess = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text style="max-height: 900px">
          <v-form @submit.prevent ref="GenerateFormRef">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  dense
                  outlined
                  color="header"
                  v-model="formData.Description"
                  :rules="[formRules.required]"
                  label="Description"
                  rows="2"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="formData.Lists"
                class="elevation-1"
              >
              <template v-slot:top>
                  <v-toolbar flat>
                    <span class="green--text text--darken-2">List Of Selected Items</span>
                  </v-toolbar>
              </template>
                <template v-slot:[`item.UnitCost`]="{ item }">
                  <span class="text-no-wrap">₱ {{ formatPrice(item.UnitCost) }}</span>
                </template>
              </v-data-table>
              </v-col>
            </v-row>
          </v-container>
          </v-form>
          </v-card-text>
          <v-card-actions class="pb-4">
            <v-spacer></v-spacer>
            <v-btn color="grey darken-2" outlined @click="dialogProcess = false">Cancel</v-btn>
            <v-btn color="green darken-2" :loading="generateLoading" class="white--text" @click="confirmGenerate()"><v-icon>mdi-sticker-plus</v-icon> Generate</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>
    
    <script>
export default {
  components:{
  },
  props: {
    display: null,
  },
  data: () => ({
    dialog: false,
    searchText: '',
    users: [],
    users_temp: [],
    dialogItemType: false,
    dialogModel: false,
    itemList: [],
    formData: {
      Lists: [],
      DocTypeID: null,
      Description: null,
    },
    disabledCount: 0,
    isLoading: false,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Added!",
      message: "",
      top: 10,
    },
    headers: [
      {
        text: "Code",
        align: "start",
        sortable: false,
        value: "Code",
      },
      {
        text: "Purpose",
        align: "start",
        sortable: false,
        value: "Purpose",
      },
      {
        text: "No. of Items",
        align: "center",
        sortable: false,
        value: "Qty",
      },
      { text: "Date Issued", align:"start", value: "IssuedDate", sortable: false },
    ],
    expanded: [],
    singleExpand: true,
    expanded2: [],
    dialogProcess: false,
    renewLoading: false,
    dispenseTypes: [],
    DispenseTypeID: null,
    process_type: null,
    UserID_temp: null,
    generateLoading: false,
    doc_types: [
      {id: 1, description: 'Inventory Custodian Slip', icon: 'mdi-file'},
      {id: 2, description: 'Property Acknowledgement Receipt', icon: ' mdi-file'},
    ],
    sticker_types: [
      {id: 1, description: 'Newly Purchased Sticker', icon: 'mdi-file'},
      {id: 2, description: 'Property Sticker', icon: ' mdi-file'},
    ],
  }),
  watch: {
    display: {
        handler(data){
            if(data == true){
                this.dialogItemType = true;
            }
        },
        deep: true
    },
  },
  created() {
    const self = this;
    this.itemList.map(item => {
      if (item.disabled) self.disabledCount += 1
    })
  },
  mounted() {
    
  },
  methods: {
    saveItemType(){
      this.dialogModel = true;
      this.getItems();
    },
    clickCloseMainDialog() {
      this.itemList = [];
      this.dialogModel = false;
      this.dialogItemType = false;
      this.eventHub.$emit("closeDisposeItems", false);
    },
    generate(){
      this.dialogProcess = true;
    },
    getItems() {
      this.unpublishBtn = false;
      this.isLoading = true;
      this.formData.Lists = [];
      this.formData.StickerTypeID = this.formData.StickerTypeID ? this.formData.StickerTypeID : 1;
      let data = new FormData();
      data.append("type", this.formData.DocTypeID);
      data.append("sticker", this.formData.StickerTypeID)
      this.axiosCall("/sticker/getDocumentByType", "POST", data).then((res) => {
        this.itemList = res.data.data;
        this.selectAllToggle({items: res.data.data, value: true})
        this.selectAllToggle({items: res.data.data, value: false})
        this.isLoading = false;
      });
    },
    confirmGenerate(){
      if(this.$refs.GenerateFormRef.validate() && this.formData.Lists.length > 0){
        let lists = JSON.parse(JSON.stringify(this.formData.Lists))
        let items = [];
        lists.forEach(item => {
          if(this.formData.DocTypeID == 1){
          items.push({ICSID: item.ICSID, IARID: item.IARID});
          }
          else if(this.formData.DocTypeID == 2){
          items.push({PARID: item.PARID, IARID: item.IARID});
          }
        });
          let data = new FormData();
          data.append("List", JSON.stringify(items));
          data.append("Description", this.formData.Description);
          data.append("type", this.formData.DocTypeID);
          data.append("sticker", this.formData.StickerTypeID);
          this.axiosCall("/sticker/add", "POST", data).then((res) => {
            if(res.data.status){
              this.dialogProcess = false
              this.getItems();
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = "All selected Items were successfully generated!";
            }
            else{
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = "Something went wrong!";
            }
            });
      }
      else{
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.message = "Unable to proceed. Please check the details before submitting!";
      }
    },
    selectAllToggle(props) {
      console.log(props)
       if(this.formData.Lists.length != this.itemList.length - this.disabledCount) {
         this.formData.Lists = [];
         const self = this;
         props.items.forEach(item => {
           if(!item.disabled) {
            // let temp = [];
            // item.MRData.forEach(item2 => {
            //   if(item2.rsdata){
            //     temp.push(item2);
            //   }
            // });
            // item.MRData_selected = temp;
            self.formData.Lists.push(item);
            self.expanded2.push(item)
           } 
         });
       } else this.formData.Lists = [];
     },
    getItemText(item) {
      return `${item.Brand ? item.Brand : 'No Brand'}` + ' | ' + `${item.Model ? item.Model : 'No Model'}` + ' | ' + `${item.SerialNo ? item.SerialNo : 'No Serial No.'}`;
    },
    getItemValue(item) {
      return item;
    },
    changeSerialNo(item){
      let temp = item.editableQty;
      item.editableQty = 0;
      item.editableQty = temp;
    },
    getDescription(id) {
      const item = this.doc_types.find(i => i.id === id)
      return item ? item.description : ''
    }
  },
};
</script>
        
    <style scoped>
.v-dialog--fullscreen,
.poModal {
  overflow-x: hidden !important;
}
</style>